<template>
  <div class="flex gap-3 items-center" :class="containerClass">
    <!-- Avatar -->
    <router-link
      v-if="linkToProfile && user?.username"
      :to="{ name: 'WebUser', params: { username: user.username } }"
      class="shrink-0"
      @click.stop>
      <UserAvatar :user="user" :size="avatarSize" class="shrink-0" />
    </router-link>
    <div v-else class="shrink-0">
      <UserAvatar :user="user" :size="avatarSize" />
    </div>

    <!-- User info -->
    <div class="flex-1 min-w-0" :class="textContainerClass">
      <router-link
        v-if="linkToProfile && user?.username"
        :to="{ name: 'WebUser', params: { username: user.username } }"
        class="block"
        @click.stop>
        <p
          class="font-medium truncate"
          :class="[nameClass, linkToProfile ? 'hover:underline' : '']">
          {{ user?.displayname || user?.username || 'User' }}
        </p>
        <p v-if="showUsername" class="text-xs text-gray-400 truncate">
          @{{ user?.username }}
        </p>
      </router-link>
      <template v-else>
        <p class="font-medium truncate" :class="nameClass">
          {{ user?.displayname || user?.username || 'User' }}
        </p>
        <p v-if="showUsername" class="text-xs text-gray-400 truncate">
          @{{ user?.username }}
        </p>
      </template>

      <!-- Optional subtitle slot -->
      <slot name="subtitle"></slot>
    </div>

    <!-- Optional right content -->
    <slot name="right"></slot>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import UserAvatar from '@/components/UserAvatar.vue'

const props = defineProps({
  user: {
    type: Object,
    default: null
  },
  size: {
    type: String,
    default: 'md',
    validator: (v) => ['sm', 'md', 'lg'].includes(v)
  },
  showUsername: {
    type: Boolean,
    default: true
  },
  linkToProfile: {
    type: Boolean,
    default: true
  },
  // For dark/light theme variants
  theme: {
    type: String,
    default: 'dark',
    validator: (v) => ['dark', 'light'].includes(v)
  }
})

const avatarSize = computed(() => {
  switch (props.size) {
    case 'sm':
      return '8'
    case 'lg':
      return '12'
    default:
      return '10'
  }
})

const containerClass = computed(() => {
  return ''
})

const textContainerClass = computed(() => {
  return ''
})

const nameClass = computed(() => {
  if (props.theme === 'light') {
    return 'text-gray-900'
  }
  return 'text-white'
})
</script>
